<script>
    import {beforeUpdate, onMount} from 'svelte';
    import Chart from 'chart.js';
    import Common from '../public/lib/common';

    export let labelsData;
    export let valuesData;
    export let titleData;

    let outer = Common.randomString();
    let inner = Common.randomString();

    beforeUpdate(() => {

        if (labelsData && labelsData.length > 0) {
            let colors = Array(labelsData.length).fill("#00aeef");
            new Chart(document.getElementById(inner), {
                type: 'bar',
                data: {
                    labels: labelsData,
                    datasets: [
                        {
                            label: "Ilość rejestracji",
                            backgroundColor: colors,
                            data: valuesData
                        }
                    ]
                },
                options: {
                    plugins: {
                        labels: false
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                fontColor: "#FFF"
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                fontColor: "#FFF"
                            }
                        }]
                    },
                    responsive: true,
                    legend: {
                        display: false,
                        labels: {
                            fontColor: "#fff"
                        }
                    },
                    title: {
                        display: true,
                        fontSize: 18,
                        fontColor: '#fff',
                        text: titleData
                    },
                }
            });
        }
    });

    onMount(async () => {
        let w = jQuery('#' + outer).width();
        jQuery('#' + outer).css({'height': w / 4 + 'px'});
        jQuery('#' + inner).css({'width': w + 'px'});
        jQuery('#' + inner).css({'height': w / 4 - 10 + 'px'});
    });


</script>

<main class="chart-container" id="{outer}">
    <canvas id="{inner}">
    </canvas>
</main>

<style>

</style>
